exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.editarTime .h2_title[data-v-d99f504c] {\n  font-weight: normal;\n}\n", ""]);

// exports
